export default __webpack_public_path__ + "static/landing-section-2-2c85842e331758b648818cbcaab12540.png";